var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showTime)?_c('span',[_vm._v("\n    "+_vm._s(_vm.formatDateTime(_vm.date))+"\n  ")]):(_vm.date)?_c('span',[_vm._v("\n    "+_vm._s(_vm.formatDate(_vm.date))+"\n  ")]):_c('span',{staticClass:"text--disabled font-italic"},[_vm._v("\n    Not available\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-249cca77","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payoutsAndTaxes/payout/shared/DateDisplay.vue
// module id = null
// module chunks = 